import React from 'react';
import c from './shortcut.module.scss';
import IconDisplay from '../../../components/icon-display/IconDisplay';

const Shortcut = ({
  shortcut,
  shouldDisplayURL,
  hasPlaceholderIcon,
  disabled,
}) => {
  const anchorProp = disabled ? {} : { href: shortcut.url };

  return (
    <a
      className={c.shortcut}
      target="_blank"
      rel="noreferrer"
      aria-description="Opens in a new window"
      onKeyDown={(e) => e.stopPropagation()}
      data-tracking-event-location="shortcuts-widget"
      {...anchorProp}
    >
      {shortcut.icon && <IconDisplay icon={shortcut.icon} url={shortcut.url} />}
      {!shortcut.icon && hasPlaceholderIcon && (
        <div className={c.placeholder}> </div>
      )}

      <div className={c.content}>
        <p className={c.shortcutName}>{shortcut.name}</p>
        {shouldDisplayURL ? (
          <p className={c.shortcutUrl}>{shortcut.url}</p>
        ) : null}
      </div>
    </a>
  );
};

export default Shortcut;
